import { useQuery } from "@tanstack/react-query";

export interface VelocityHeader {
  parameterUnit: string;
  parameterNumber: number;
  parameterNumberName: string;
  parameterCategory: number;
  dx: number;
  dy: number;
  nx: number;
  ny: number;
  lo1: number;
  lo2: number;
  la1: number;
  la2: number;
  refTime: string;
}

export interface VelocityDatum {
  header: VelocityHeader;
  data: number[];
}

export interface MapBounds {
  north: number;
  south: number;
  east: number;
  west: number;
}

async function fetchWindData(bounds: MapBounds, hour: number): Promise<VelocityDatum[]> {
  const params = new URLSearchParams({
    north: bounds.north.toFixed(2),
    south: bounds.south.toFixed(2),
    east: bounds.east.toFixed(2),
    west: bounds.west.toFixed(2),
    hour: String(hour),
  });
  const res = await fetch(`/api/wind?${params}`);
  if (!res.ok) throw new Error(`Wind API error ${res.status}`);
  return res.json();
}

export function useWindData(bounds: MapBounds | null, hour: number) {
  return useQuery({
    queryKey: [
      "wind",
      bounds?.north.toFixed(2),
      bounds?.south.toFixed(2),
      bounds?.east.toFixed(2),
      bounds?.west.toFixed(2),
      hour,
    ],
    queryFn: () => fetchWindData(bounds!, hour),
    enabled: bounds !== null,
    staleTime: 30 * 60 * 1000,
    refetchInterval: 30 * 60 * 1000,
    retry: 2,
  });
}
